<script setup name="ZoomEnhancedMediaDetails">
import { ZmPlayer } from '@zoom/zoom-ui-vue3';
import ZoomLogo from '@/assets/plans/logo_zoom.svg';
import FeatureCheck from '@/assets/plans/re-checked.svg';
import PriceList from '@/components/price-list.vue';
import BillingDialog from '@/components/billing-dialog.vue';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:visible']);

const zoomMediaDetailsVideoSrc = 'https://st1.zoom.us/opc/details/enhance-media.mp4';
</script>
<template>
<billing-dialog 
  :modelValue="visible" 
  @update:modelValue="emit('update:visible', $event)" 
  show-close 
  class="zoom-enhanced-media-details" 
  :style="{ '--feature-check-url': `url(${FeatureCheck})` }"
  @back-event="emit('update:visible', false)"
>
  <div class="zoom-enhanced-media-details__content">
    <div class="zoom-enhanced-media-details__header">
      <img :src="ZoomLogo" alt="" class="zoom-enhanced-media-details__logo">
      <h1 class="zoom-enhanced-media-details__title">
        {{ $t('billing.zoom_enhanced_media.title') }}
      </h1>
    </div>
    <div class="zoom-enhanced-media-details__price">
      <price-list plan-category="zenmd" />
    </div>
    <ul class="zoom-enhanced-media-details__features">
      <li class="zoom-enhanced-media-details__feature">{{ $t('billing.zoom_enhanced_media.feature-1') }}</li>
      <li class="zoom-enhanced-media-details__feature">{{ $t('billing.zoom_enhanced_media.feature-2') }}</li>
      <li class="zoom-enhanced-media-details__feature">{{ $t('billing.zoom_enhanced_media.feature-3') }}</li>
      <li class="zoom-enhanced-media-details__feature">{{ $t('billing.zoom_enhanced_media.feature-4') }}</li>
      <li class="zoom-enhanced-media-details__feature">{{ $t('billing.zoom_enhanced_media.feature-5') }}</li>
      <li class="zoom-enhanced-media-details__feature">{{ $t('billing.zoom_enhanced_media.feature-6') }}</li>
    </ul>
    <zm-player :src="zoomMediaDetailsVideoSrc" single-line class="zoom-enhanced-media-details__video"/>
  </div>
</billing-dialog>
</template>
<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

.zoom-enhanced-media-details {
  &.zbo-dialog {
    width: 520px;
    padding: 72px 0;
    .zoom-enhanced-media-details__content {
      padding: 0 60px;
    }
  }
  &.zbo-dialog.opc-modal-dialog {
    padding: 28px !important;
  }
  .zbo-dialog__header {
    padding: 0;
  }
  .zbo-dialog__body {
    padding: 0;
  }
  .zbo-dialog__body.is-lost-footer {
    margin: 0;
  }
}
.zoom-enhanced-media-details__logo {
  margin-bottom: 4px;
}

.zoom-enhanced-media-details__title {
  color: var(--zoom-color-text-subtler-neutral, #666487);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 24px */
  margin-bottom: 15px;
}

.zoom-enhanced-media-details__features {
  list-style: none;
  padding: 0;
  margin-top: 15px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.zoom-enhanced-media-details__feature {
  position: relative;
  padding-left: 26px;
  color: var(--light-foreground-foreground, #00053D);
  font-family: 'Almaden Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
    background-image: var(--feature-check-url);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 0 0;
  }
  .zbo-player .vjs-error-page-wrapper {
    border-radius: 15px;
  }
}
</style>